import { render, staticRenderFns } from "./bindPromoter.vue?vue&type=template&id=4e22f64a"
import script from "./bindPromoter.vue?vue&type=script&lang=js"
export * from "./bindPromoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports